"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _sharedModal = _interopRequireDefault(require("../../elements/other/shared-modal"));
var _rtbCardModalItem = _interopRequireDefault(require("./rtb-card-modal-item"));
const ModalWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ModalWrapper",
  class: "pl-m11h1s4q"
});

/**
 * QuickLearnModal Component.
 *
 * @param {Object} props React props
 * @param {string} props.id Modal id
 * @param {string} props._name Modal name
 * @param {boolean} props.show Show modal
 * @param {Function} props.onClose Close modal function
 * @param {Object} props.selectedCard Selected card object
 * @returns {React.ReactElement} QuickLearnModal Component
 * @public
 */

function QuickLearnModal({
  id,
  _name,
  show,
  onClose,
  selectedCards,
  ...rest
}) {
  const idHash = `${id}-card-modal`;
  return /*#__PURE__*/_react.default.createElement(ModalWrapper, {
    "data-cy": "modal-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_sharedModal.default, {
    id: idHash,
    show: show,
    onClose: onClose,
    modalHash: idHash,
    eager: true
  }, /*#__PURE__*/_react.default.createElement(_rtbCardModalItem.default, (0, _extends2.default)({
    id: `${id}-modal`,
    _name: _name,
    cards: selectedCards
  }, rest))));
}
var _default = exports.default = QuickLearnModal;
QuickLearnModal.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  show: _propTypes.default.bool,
  onClose: _propTypes.default.func,
  selectedCards: _propTypes.default.array
};